import { render, staticRenderFns } from "./EventPageNew.vue?vue&type=template&id=3c72fbd8&scoped=true&lang=pug"
import script from "./EventPageNew.vue?vue&type=script&lang=js"
export * from "./EventPageNew.vue?vue&type=script&lang=js"
import style0 from "./EventPageNew.vue?vue&type=style&index=0&id=3c72fbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c72fbd8",
  null
  
)

export default component.exports